import React, {useEffect} from "react";
import "../App.css";
import Logo from "../Assets/logo.png"
import { useNavigate} from "react-router-dom";
import Copyright_Footer from "../Components/copyrightFooter";
// import background from "../OLDassets/background.gif";

export default function Landing() {
    const navigate = useNavigate();
    const handleLogin = () => {
        navigate("/login");
    };
  const handleRegister = () => {
    navigate("/register");
  };

    useEffect(() => {
        if (localStorage.getItem('authToken')) {
            navigate("/home");
        }
    }, [localStorage]);

    return (
        <div className="container mobile-page" style={{marginTop: '10em'}}>
                <div className="text-center" >
                    <img src={Logo} alt="Logo" className='logo'/>
                </div>

                <div className="landing-page col-12 col-md-12 col-xl-12 d-flex justify-content-center align-items-center flex-column">
                    <button className="landing-btn px-4 py-3 rounded-3 pink" onClick={handleLogin}>
                        Sign in
                    </button>

                    <button className="mt-4 landing-btn px-4 py-3 rounded-3 deepBlack" onClick={handleRegister} >
                      Register
                    </button>
                </div>
            <Copyright_Footer/>
        </div>
    );
}
